<template>
    <button
        type="button"
        class="kgr-button"
        :class="[variantClass, sizeClass]"
        :disabled="pending || disabled"
        :title="title"
        @click="$emit('click', $event)"
    >
        <kgr-icon-add
            v-if="iconAdd"
            class="kgr-icon--small kgr-icon--highlight kgr-icon--circle kgr-button__icon kgr-button__icon--left"
        />
        <kgr-icon
            v-if="icon"
            :icon-class="icon"
            class="kgr-button__icon kgr-button__icon--left"
            :class="{'kgr-icon--small': !small, 'kgr-icon--tiny': small}"
        />
        <kgr-loading
            v-if="pending"
            inline
        />
        <span v-else>{{ value }}<slot></slot></span>
    </button>
</template>

<script>
import Icon from '../../icon/Icon.vue';
import IconAdd from '../../icon/IconAdd.vue';
import Loading from '../../Loading.vue';

export default {
    components: {
        'kgr-loading': Loading,
        'kgr-icon-add': IconAdd,
        'kgr-icon': Icon,
    },
    props: {
        value: {
            type: String,
            required: false,
            default: '',
            example: 'My Button',
        },
        iconAdd: {
            type: Boolean,
            required: false,
            default: false,
        },
        icon: {
            type: String,
            required: false,
            default: null,
        },
        pending: {
            type: Boolean,
            required: false,
            example: false,
        },
        type: {
            type: String,
            required: false,
            default: 'blue',
            example: 'blue',
        },
        title: {
            type: String,
            required: false,
            default: '',
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        small: {
            type: Boolean,
            required: false,
            default: false,
        },
        big: {
            type: Boolean,
            required: false,
            default: false,
        },

    },
    computed: {
        variantClass() {
            switch (this.type) {
                case 'blue':
                    return 'kgr-button--accent';
                case 'red':
                    return 'kgr-button--danger';
                case 'link':
                    return 'kgr-button--link';
                case 'grey':
                default:
                    return '';
            }
        },
        sizeClass() {
            if (this.small) {
                return 'kgr-button--small';
            }
            if (this.big) {
                return 'kgr-button--big';
            }

            return '';
        }
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
